<template>
    <div class="card">
        <div v-if="Rtoken === false">
            <div class="card-header">
                <h4 v-if="registrarTlf">Register Phone</h4>
                <h4 v-else-if="sendSMS">Confirm</h4>
                <h4 v-else-if="formLogin">Sign In</h4>
                <h4 v-else>Forgot Password</h4>                
            </div>
            <form @submit.prevent="sendform" v-if="registrarTlf">
                <div class=" card-body">
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <div class="alert alert-danger" role="alert" v-if="messageError != null">
                                        <b>Error: </b>{{messageError}}
                                    </div>
                                    <!-- <label for="email">E-mail</label> -->
                                    <div class="password-input">
                                        <span class="showpassord " action="hide" >
                                            <i class="fas fa-phone"></i>
                                        </span>
                                        <input id="phone" type="text" class="form-control" name="phone" v-model="register.phone" placeholder="Phone" autocomplete="phone" required>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
                <div class="card-footer">
                    <div v-if="!isLoading">
                        <button type="submit" class="btn btn-success btn-login">Register</button>
                        <button type="button" class="btn btn-sing creat-account" @click="backLogin">Go to login </button>
                    </div>
                    <div v-else>
                        <Loader></Loader>
                    </div>
                </div>
            </form> 
            <form @submit.prevent="sendform" v-else>
                <div class=" card-body">
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <div class="form-row" v-if="formLogin">
                                <div class="form-group col-md-12">
                                    <div class="alert alert-danger" role="alert" v-if="messageError != null">
                                        <b>Error: </b>{{messageError}}
                                    </div>
                                    <!-- <label for="email">E-mail</label> -->
                                    <div class="password-input">
                                        <span class="showpassord " action="hide" >
                                            <i class="fas fa-user"></i>
                                        </span>
                                        <input id="email" type="email" class="form-control" name="email" v-model="userCredenctial.email" placeholder="Email address" autocomplete="email" required>
                                    </div>
                                </div>
                                <div class="form-group col-md-12" style="margin-bottom: 0px;">
                                    <!-- <label for="password">Password</label> -->
                                    <div class="password-input">
                                        <span class="showpassord icon-eye" action="hide" @click="shoPass">
                                            <i class="fas fa-eye" v-if="showpassword"></i>
                                            <i class="fas fa-eye-slash" v-else></i>
                                        </span>
                                        <input id="password" :type="typepassword" class="form-control" v-model="userCredenctial.password" name="password" placeholder="Password"  autocomplete="new-password" required>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row" v-else>
                                <div class="form-group col-md-12">
                                    <div class="alert alert-danger" role="alert" v-if="messageError != null">
                                        <b>Error: </b>{{messageError}}
                                    </div>
                                    <div class="alert alert-success" role="alert" v-if="messageSuccess">
                                        <b>Greath, </b>a recovery token has been sent to your account.
                                    </div>
                                    <label for="email">Phone: </label> 
                                    <div class="password-input">
                                        <span class="showpassord " action="hide" >
                                            <i class="fas fa-phone-alt"></i>
                                        </span>
                                        <input id="phoneForgot" type="text" class="form-control" name="phone" v-model="userCredenctial.phone" placeholder="Phone" autocomplete="phone" >
                                    </div>
                                    <br>
                                    <label for="email">Or Email: </label> 
                                    <br>
                                    <div class="password-input">
                                        <span class="showpassord " action="hide" >
                                            <i class="fas fa-at"></i>
                                        </span>
                                        <input id="emailForgot" type="text" class="form-control" name="email" v-model="userCredenctial.email" placeholder="Email" autocomplete="email" >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 note" v-if="formLogin">
                            <a href="#" @click="forgot">
                                Forgot Password? 
                            </a>
                        </div>
                        <div class="col-md-6 note" v-if="formLogin">
                            <!-- <a href="#" @click="RtokenActivation">
                                Resend Activation
                            </a> -->
                        </div>                    
                    </div> 
                </div>
                <div class="card-footer">
                    <div v-if="!isLoading">
                        <button type="submit" v-if="formLogin" class="btn btn-success btn-login">Sign In</button>
                        <a class="btn btn-sing creat-account" v-if="formLogin" :href="urlPage + 'billing'" target="_blank">Create Account </a>
                        <button type="submit" v-if="!formLogin" class="btn btn-success btn-login">Send Forgot</button>
                        <button type="button" class="btn btn-sing creat-account" v-if="!formLogin" @click="backLogin">Go to login </button>
                    </div>
                    <div v-else>
                        <Loader></Loader>
                    </div>
                </div>
            </form>            
        </div>
        <div v-else>
            <formRtoken></formRtoken>
            <button type="button" class="btn btn-sing creat-account Ajust" style="" @click="backLogin">Go to login </button>
        </div>
    </div>
</template>
<script>
import Loader from '@/core/components/shared/Loader'
import formRtoken from '@/core/components/Login/formRtoken'
export default {
    name: 'formLogin',
    components: {
        Loader,
        formRtoken
    },
    data () {
        return {
            messageError: null,
            userCredenctial: {
                email: '',
                phone: '',
                password: '',
                typeU: 'client'
            },
            isLoading: false,
            showpassword: false,
            typepassword: 'password',
            urlPage: window.urlweb,
            sendSMS: false,
            formLogin: true,
            messageSuccess: false,
            Rtoken: false,
            formvalid: false,
            registrarTlf: false,
            codeSMS: '',
            register: {
                phone: '',
                user_idR: 0,
            },
        }
    },
    created(){
    },
    methods: {
        RtokenActivation(){
            this.Rtoken = true
        },
        sendForgot() {
            let t = this;
            t.isLoading = true;
            window.masterApiv2.post("sendforgot", {
                phone: t.userCredenctial.phone,
                username: t.userCredenctial.email,
            })
            .then(response => {
                t.userCredenctial.email = '';
                t.userCredenctial.phone = '';
                t.isLoading = false;
                if(!response.data.status){
                    t.messageError= 'Error, account not registered';
                    t.messageSuccess = false;
                } else {
                    // t.messageSuccess = true;
                    t.messageError= null;
                    if(response.data.validPhone){
                        this.$notify({
                            group: 'noti',
                            type: 'success',
                            title: 'Greath',
                            text: 'a recovery code has been sent to your phone number.',
                            duration: 10000
                        });
                    }else{
                        // se envio al correo
                        this.$notify({
                            group: 'noti',
                            type: 'success',
                            title: 'Greath',
                            text: 'a recovery token has been sent to your account.',
                            duration: 10000
                        });
                    }
                    setTimeout(function(){
                        t.$router.push({name: "Forgot"});
                    }, 5000);
                }
            })
            .catch(error => {
                console.log(error);
                t.isLoading = false;
                t.messageError= 'Error de conexion';
                t.messageSuccess = false;
            });
        },
        backLogin() { 
            this.formLogin = true;
            this.registrarTlf = false;
            this.Rtoken = false;
        },
        forgot() { 
            this.formLogin = false;
        },
        sendform() { 
            // debugger;
            if(localStorage.getItem('loginSMS') == 1){
                //this.sendSMS = true;    
            } else {
                this.sendSMS = false;    
            }
            if(this.registrarTlf){
                this.registerSMS();
            }
            else if(this.sendSMS && !this.formvalid) {
                this.sendSMSverify();
            }
            else if(this.formLogin) {
                this.loginInterno();
            }
            else {
                this.sendForgot();
            }
        },
        registerSMS() {
            this.isLoading = true;
            this.messageError=null;
            console.log('u', this.register.user_idR)
            this.$store.dispatch('core/session/registerSMS', {
              user_id: this.register.user_idR,
              phone: this.register.phone,
            })
            .then(response => {
                this.isLoading = false;
                if(!response.status){
                    this.registrarTlf= true;
                    this.messageError= 'Error register';
                }else{
                    console.log('redirec interno home'); 
                    this.formvalid = true;
                    this.registrarTlf= false;
                }
            }).catch((error) => {
                console.log(error);
                this.isLoading = false;
                this.messageError= 'Error de conexion';
            })
        },
        sendSMSverify() {
            this.isLoading = true;
            this.messageError=null;
            this.$store.dispatch('core/session/sendSMSverify', {
              email: this.userCredenctial.email,
            })
            .then(response => {
                this.isLoading = false;
                if(!response.status){
                    this.registrarTlf= true;
                    this.register.user_idR = response.user_id;
                }else{
                    console.log('redirec interno home'); 
                    this.formvalid = true;
                    this.registrarTlf= false;
                }
            }).catch((error) => {
                console.log(error);
                this.isLoading = false;
                this.messageError= 'Error de conexion';
            })
        },
        loginInterno() {
            this.isLoading = true;
            this.messageError=null;
            this.$store.dispatch('core/session/loginInterno', {
              email: this.userCredenctial.email,
              password: this.userCredenctial.password
            })
            .then(response => {
                this.isLoading = false;
                if (response !== 'warning') {
                    if(!response){
                        console.log(response);
                        this.messageError= 'incorrect username / password';
                    }else{
                        console.log('redirec interno home');
                        //debugger;
                        // recargar browser para obtener nueva valoracion de datos 
                        window.top.location.replace(window.self.location.href + '?a=' + window.getStart);
                    }
                } else {
                    this.messageError= 'your account was suspended. Please contact your administrator at support@marketea.com or Call us at 774-287-3353'
                }
            }).catch((error) => {
                console.log(error);
                this.isLoading = false;
                this.messageError= 'Error de conexion';
            })
        },
        shoPass() {
            this.showpassword = !this.showpassword;
            // console.log('password show ', this.showpassword);
            if(this.showpassword){ this.typepassword = true;}
            else{ this.typepassword= 'password';}
        }
    }   
};
</script>

<style lang="css" scoped>
.card {
    background-color: #fbfbfb;
    border: 1px solid #ddd;
    box-shadow: 1px 1px 1px #dbdbda;
    position: relative;
    border-radius: 2px;
    margin-top:0px;
}
.card-header {
    padding: 15px 13px;
    margin: 0;
    border-bottom: 1px solid #ddd;
    background: rgba(248,248,248,.9);
}
.card-header h4 {
    margin-bottom: 0px;
    color: #555;
}
.card-footer {
    display: block;
    padding: 7px 14px 15px;
    border-top: 1px solid #ddd;
    background: rgba(248,248,248,.9);
}
button.btn.btn-success.btn-login {
    padding: 2px 20px;
    border-color: #031099;
    background-color: #031099;
    box-shadow:none;
}
.btn-sing {
    padding: 2px 10px;
    color: #1f1f1f ;
    background-color: #01972000 ;
    border-color: #1f1f1f ;
    border-radius: 2px;
    float: right;
}
.creat-account{
    border-color: #aaa ;
}
form label {
    display: block;
    margin-bottom: 6px;
    line-height: 19px;
    font-weight: 400;
    font-size: 13px;
    color: #333;
    text-align: left;
    white-space: normal;
}
.form-control {
    border: 0px solid #bdbdbd;
    background-color: #fbfbfb !important;
    height: 50px;
    border-bottom: 1px solid #bdbdbd;
    border-radius: 0px;
}
.form-control:focus {
    background-color: #fbfbfb !important;
}
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus 
input:-internal-autofill-selected
{
    -webkit-box-shadow: 0 0 0px 1000px #fbfbfb inset;
    background-color: #fbfbfb !important;
}
.showpassord{
    height: 50px;
    border-left: 0px solid;
}
.note {
    margin-top: 6px;
    padding: 0 15px;
    font-size: 11px;
    line-height: 15px;
    color: #999;
}
.note a {
    margin-top: 20px;
    font-size: 14px;
    display: block;
    text-align: right;
}
@media (max-width: 1190px){
    .btn.btn-success.btn-login,
    .btn.btn-sing.creat-account {
        display: block;
        margin: 10px auto;
        width: 80%;
        height: 40px;
        font-size: 20px;
        float: initial;
    }
    .Ajust {
        width: 74% !important; 
        margin-top: -13px !important;
    }      
}
@media (min-width: 1190px){
    .Ajust {
        width: 90px !important;
        margin-right: 15px !important;
        margin-top: -42px !important;
        position: absolute !important;
        right: 1px !important;
    }      
}

@media (max-width: 767px){
    .card {
        max-width: 330px;
        margin: auto;
    }
}
@media (max-width: 350px){
    .card {
        max-width: 300px;
        margin: auto;
    }
}
</style>
